<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="isView ? '详情' : model.pkId ? '编辑' : '新建'"
      width="1350px"
      class="adaptationModal"
      @close="$reset('form')"
  >
    <!-- Begin -->
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="isView"
        :model="model"
        :rules="ruleValidate"
        class="form"
        label-width="90px"
    >
      <div class="editTitle">调拨单信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="单据编号">
            <el-input v-model="model.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="isPosting" :span="12">
          <el-form-item label="过账时间">
            <el-date-picker
                v-model="model.postTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <!--        <el-col :span="12">-->
        <!--          <el-form-item label="生产中心" prop="relBillName">-->
        <!--            <el-select v-model="model.relBillName" filterable placeholder="请选择生产中心" @change="workCenterSelect">-->
        <!--              <el-option v-for="item in workCenterList" :key="item.pkId" :label="item.workCenterName" :value="item.pkId"/>-->
        <!--            </el-select>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <!--        <el-col :span="12">-->
        <!--          <el-form-item label="要求时间" prop="requireDate">-->
        <!--            <el-date-picker-->
        <!--                v-model="model.requireDate"-->
        <!--                placeholder="请选择要求时间"-->
        <!--                type="datetime"-->
        <!--                style="width: 100%"-->
        <!--                value-format="yyyy-MM-dd HH:mm:ss"-->
        <!--            />-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <el-col>
          <el-form-item label="备注" prop="note">
            <el-input v-model="model.note" type="textarea" placeholder="备注"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">调拨单明细</div>
      <div style="margin-bottom: 7px">
        <el-button
            type="primary"
            @click="$refs.selectMaterial.open()">
          添加物料
        </el-button>
      </div>
      <el-table
          border
          stripe
          :data="model.details"
          show-summary
          :summary-method="getSummary">
        <el-table-column prop="materialNo" width="90" align="center" label="物料编号"/>
        <el-table-column prop="materialName" width="200" label="物料名称"/>
        <el-table-column prop="mappingMaterialNo" label="旧物料"/>
        <el-table-column prop="outLocationNo" width="140" label="调出仓位">
          <template slot-scope="scope">
            <el-select v-model="scope.row.outLocationNo" placeholder="请选择">
              <el-option
                  v-for="item in constants.locationNo.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="inLocationNo" width="140" label="调入仓位">
          <template slot-scope="scope">
            <el-select v-model="scope.row.inLocationNo" placeholder="请选择">
              <el-option
                  v-for="item in constants.locationNo.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="locationNo" label="小仓位"/>
        <el-table-column prop="locationNumber" label="库存"/>
        <el-table-column prop="quantity" width="154" align="center" label="调拨数量">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :disabled="isPosting" :min="0" @change="(val) => handleQuantityChange(scope.$index, val)"/>
          </template>
        </el-table-column>
        <el-table-column prop="instockQty" width="155" align="center" label="过账数量">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.instockQty" :disabled="!isPosting" :min="0" @change="(val) => handleInstockQtyChange(scope.$index, val)"/>
          </template>
        </el-table-column>
        <el-table-column prop="unInstockQty" label="未过帐数量"/>
        <el-table-column fixed="right" label="操作" width="70" align="center">
          <template slot-scope="scope">
            <el-button type="danger" @click="model.details.splice(scope.$index, 1)"> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <!-- End -->
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <template v-if="!isView">
        <el-button
            v-if="!isPosting"
            :loading="submitLoading"
            type="primary"
            @click="handleOk">保存</el-button>
        <el-button v-if="isPosting" :loading="submitLoading" type="primary" @click="postToSap">过账</el-button>
      </template>
    </span>
    <material-select ref="selectMaterial" :is-multi-select="true" @select-change="materialSelect"/>
  </el-dialog>
</template>

<script>
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import constants from "@/util/constants";

  export default {
    components: {
      MaterialSelect,
    },
    props: {
      isView: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        constants,
        dialogVisible: false,
        submitLoading: false,
        isPosting: false,
        contentLoading: false,
        model: {
          pkId: 0,
          billNo: "",
          relBillName: "",
          requireDate: "",
          note: "",
          details: [],
          postTime: "",
        },
        workCenterList: [],
        inWarehouseNo: "", // 调入仓库编号
        inWarehouseName: "", // 调入仓库名称
        ruleValidate: {
          relBillName: {required: true, message: "生产中心不能为空", trigger: "change"},
          requireDate: {required: true, message: "要求时间不能为空", trigger: "change"},
        },
      };
    },

    methods: {
      open(row, isPosting) {
        this.dialogVisible = true;
        this.isPosting = isPosting;
        this.$nextTick(() => {
          // this.getWorkCenterList();
          if (row) {
            this.getData(row.pkId);
          }
        });
      },

      getData(pkId) {
        this.contentLoading = true;
        this.$http
          .get("basic", `transferBills/${pkId}`)
          .then((res) => {
            if (res.success) {
              this.model = Object.assign(this.model, res.data);
              this.model.postTime = this.getFormatDate(new Date());
              this.model.details.forEach(item => {
                if (!item.instockQty) {
                  item.instockQty = item.quantity;
                }
                item.unInstockQty = Number(item.quantity) - Number(item.instockQty);
              });
              // const result = this.workCenterList.find((item) => item.pkId === res.data.relBillId);
              // this.inWarehouseNo = result.warehouseNo;
              // this.inWarehouseName = result.warehouseName;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate + " 00:00:00";
      },
      materialSelect(row) {
        let obj;
        row.forEach(item => {
          obj = {
            materialId: item.id,
            materialNo: item.no,
            materialName: item.name,
            quantity: 1,
            unit: item.unit,
            mappingMaterialNo: item.mappingMaterialNo,
            locationNo: item.locationNo,
            locationNumber: item.locationNumber,
          };
          this.model.details.push(obj);
        });
      },

      handleOk() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.model.details.length) {
              this.$confirm("调拨单明细不能为空", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.submitLoading = true;
            this.$http
              .save("basic", "transferBills", this.model)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.model.pkId) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      postToSap() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.model.details.length) {
              this.$confirm("入库明细不能为空", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.submitLoading = true;
            this.$http
              .post("basic", "transferBills/postToSap", this.model)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
                this.$message.error("操作失败");
              });
          }
        });
      },

      getSummary({ columns, data }) {
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.property === "quantity" || column.property === "instockQty" || column.property === "unInstockQty") {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = "";
          }
        });
        return sums;
      },

      handleQuantityChange(index, val) {
        const detail = this.model.details[index];
        detail.quantity = val || 0;
        detail.unInstockQty = Number(detail.quantity) - Number(detail.instockQty);
        this.updateSummary();
      },

      handleInstockQtyChange(index, val) {
        const detail = this.model.details[index];
        detail.instockQty = val || 0;
        detail.unInstockQty = Number(detail.quantity) - Number(detail.instockQty);
        this.updateSummary();
      },

      updateSummary() {
        this.model.details = [...this.model.details];
      },

    },
  };
</script>
